enum CodeEditorBuiltinThemes {
	White = 'vs',
	Dark = 'vs-dark',
	Black = 'hc-black'
}

export default CodeEditorBuiltinThemes;
